define('libs/validation',['require','libs/validation.validations','libs/utilities.element.dataset'],function(require) {

    'use strict';

    var validations = require('libs/validation.validations'),
        getDataset = require('libs/utilities.element.dataset');

    var SETTINGS = {
        classValid: 'valid', // class an element gets when it passes validation.
        classInvalid: 'invalid', // class an element gets when it fails validation.
        markAncestor: '', // The element's ancentor to mark as valid/invalid (css selector).
        liveValidation: true, // validate on keydown, paste, cut.
        emptyIsValid: true, // empty fields are treated as valid (when not required).
        validations: {} // any custom validation functions.
    };

    var Validation = function() {
        this.init.apply(this, arguments);
    };

    /**
     * Initialize the component.
     * @param {jQuery} element The element to manipulate.
     * @param {Object} settings The settings for the component.
     */
    Validation.prototype.init = function(element, settings) {
        this.element = element;
        this.$element = $(element);
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.validations = $.extend({}, validations, this.settings.validations);

        // check if the element is an single input or some container with multiple inputs.
        var isInput = this.element.tagName.match(/input|select|textarea/i);
        this.isInput = isInput && !!isInput[0];

        this.$element.bind('change', this.onValidationEvent.bind(this));
        if (this.settings.liveValidation) {
            this.liveValidationStarter = this.startLiveValidation.bind(this);
            this.$element.bind('change', this.liveValidationStarter);
        }
    };

    /**
     * Check if we should start listening for user input.
     * @param {Event} event The change event.
     */
    Validation.prototype.startLiveValidation = function(event) {
        $(event.target).data('changed.validation', true);
        var allChanged = true;
        var isText = true;

        if (this.inputs) {
            // for multiple inputs, check if all are textinputs.
            this.inputs.each(function(i, input) {
                isText = this.isTextInput(input);
                return isText;
            }.bind(this));

            if (isText) {
                // check if all inputs in the group have changed.
                allChanged = this.checkChanged(this.inputs);
            }
        } else {
            isText = this.isTextInput(event.target);
        }

        if (isText && allChanged) {
            // if all inputs have changed, start live validation.
            this.$element.bind('keyup', this.onValidationEvent.bind(this));

            // cut and paste event get fired before the value actually changes.
            var delayedChange = function(event) {
                setTimeout(this.onValidationEvent.bind(this, event), 10);
            };
            this.$element.bind('cut', delayedChange.bind(this));
            this.$element.bind('paste', delayedChange.bind(this));

            // stop listening for change event to start this functionality.
            this.$element.unbind('change', this.liveValidationStarter);
        }
    };

    /**
     * Check if all inputs inside a container have changed.
     * @param {jQuery} inputs The inputs to check.
     * @return {Boolean} The value of the input has changed.
     */
    Validation.prototype.checkChanged = function(inputs) {

        if (this.$element.data('changed.validation')) return true;
        if (inputs.attr('type').match(/radio|checkbox/)) return true;

        var allChanged = true;
        inputs.each(function() {
            if (!$(this).data('changed.validation')) allChanged = false;
            return allChanged;
        });

        this.$element.data('changed.validation', allChanged);
        return allChanged;
    };

    /**
     * Get the value of one or multiple inputs.
     * @param {jQuery} element The input(s) to get the value of.
     */
    Validation.prototype.getValue = function(element) {
        var value = '';
        element.each(function() {
            if (this.type.match(/radio|checkbox/)) {
                if (this.checked) {
                    value = this.value;
                    return false;
                }
            } else value += this.value;
        });

        return value;
    };

    /**
     * Check if in element is a text input.
     * @param {Element} element The element to check.
     * @return {Boolean} The element is a text input.
     */
    Validation.prototype.isTextInput = function(element) {
        var type = element.getAttribute('type') || '';
        return element.tagName.match(/input|textarea/i) && !type.match(/radio|checkbox|button|submit|reset/i);
    };

    /**
     * Handle the input change.
     * @param {Event} event The change event.
     * @param {Element} validateMe The element to validate.
     * @param {Boolean} noChangedCheck Do not check if the input has changed.
     * @param {Boolean} noMarking Do not mark the input as valid/invalid.
     */
    Validation.prototype.onValidationEvent = function(event, noChangedCheck, validateMe, noMarking) {

        var trigger = $(validateMe || event.target);
        // mark the element as changed.
        trigger.data('changed.validation', true);

        // if element is an input
        if (this.isInput) {
            var value = this.getValue(this.$element);
            var valid = this.validate(value, trigger);
        } else {
            // if it is another element look for inputs inside it.
            this.inputs = this.inputs || this.$element.find('input');
            if (this.inputs[0] && (noChangedCheck || this.checkChanged(this.inputs))) {
                value = this.getValue(this.inputs);
                valid = this.validate(value, this.inputs, this.$element);
            }
            // if not all inputs in the group have changed, do nothing.
            else return;
        }

        if (!noMarking) {
            // Mark the element(s) as valid or invalid.
            if (valid && !value.match(/\S/)) {
                var state = 'default';
            } else {
                state = valid ? 'valid' : 'invalid';
            }
            var toMark = typeof this.inputs !== 'undefined' && this.inputs.attr('type') != 'radio' ?
                this.inputs : this.$element;
            this.setState(toMark, state);
        }

        // broadcast the outcome of the validation.
        this.$element.trigger('validate.validation', {
            element: this.$element,
            result: state
        });
    };

    /**
     * Validate the input.
     * @param {String} value The value of the input(s).
     * @param {jQuery} element The input(s) to validate.
     * @return {Boolean} The value of the element is valid.
     */
    Validation.prototype.validate = function(value, element) {
        var valid = true;

        // check required first.
        if ('required' in this.element.attributes || 'data-required' in this.element.attributes) {
            valid = this.validations.required(value);
            if (!valid) return false;
        } else if (this.settings.emptyIsValid) {
            // if not required and the field is empty, validation passes.
            if (!value.match(/\S/)) return true;
        }

        // check if there is a validation for the element's type.
        var type = element.attr('type');
        if (type) var typeLC = type.toLowerCase();
        if (type && this.validations[typeLC]) {
            valid = this.validations[typeLC](value, element);
            if (!valid) return false;
        }

        // check if there are validations for any of the element's data-attributes.
        this.dataset = this.dataset || getDataset(this.element);
        for (var key in this.dataset) {
            if (this.dataset.hasOwnProperty(key)) {
                key = key.toLowerCase();
                if (key in this.validations) {
                    valid = this.validations[key](value, element, this.dataset[key]);
                }
                if (!valid) break;
            }
        }

        return valid;
    };

    /**
     * Mark the input as valid.
     * @param {jQuery} element The input to mark.
     * @param {String} state The state to set.
     */
    Validation.prototype.setState = function(element, state) {
        var validClassAction = state == 'valid' ? 'addClass' : 'removeClass';
        var invalidClassAction = state != 'invalid' ? 'removeClass' : 'addClass';
        // mark the validated element.
        element[validClassAction](this.settings.classValid);
        element[invalidClassAction](this.settings.classInvalid);
        element = element.first();
        // mark an element's ancestor.
        var ancestor = this.settings.markAncestor ?
            element.closest(this.settings.markAncestor) : element.parent();
        ancestor[validClassAction](this.settings.classValid);
        ancestor[invalidClassAction](this.settings.classInvalid);
        if (ancestor[0] != this.$element[0]) {
            // mark the validation element.
            this.$element[validClassAction](this.settings.classValid);
            this.$element[invalidClassAction](this.settings.classInvalid);
        }
    };

    // make the component available as jQuery plugin.
    $.fn.validation = function(settings) {
        $(this).each(function() {
            if (!$(this).data('Validation')) {
                $(this).data('Validation', new Validation(this, settings));
            }
        });
    };


    /**
     * Form validation
     *
     * Listens to validations of child form elements.
     * Checks validations on submit.
     */

    var ValidationForm = function() {
        this.init.apply(this, arguments);
    };

    var SETTINGS_FORM = {
        classValid: 'valid', // class an element gets when it passes validation.
        classInvalid: 'invalid', // class an element gets when it fails validation.
        markAncestor: '', // The element's ancestor to mark as valid/invalid (css selector).
        liveValidation: true, // validate on keydown, paste, cut.
        emptyIsValid: true, // empty fields are treated as valid (when not required).
        validations: {}, // any custom validation functions.
        validationSelector: 'input, textarea, select'
    };

    /**
     * Initialize the component.
     * @param {jQuery} element The element to manipulate.
     * @param {Object} settings The settings for the component.
     */
    ValidationForm.prototype.init = function(element, settings) {
        this.element = element;
        this.$element = $(element);
        this.settings = $.extend({}, SETTINGS_FORM, settings || {});

        // disable browser native form validation.
        this.element.setAttributeNode(document.createAttribute('novalidate'));

        // create the registry for keeping track of validation states.
        this.validationStates = {
            valid: [],
            invalid: []
        };

        if (this.settings.validationSelector) {
            // initialize all elements that have validation.
            this.initializeValidations(this.settings.validationSelector);
        }

        this.$element.bind('submit', this.onSubmit.bind(this));
        // fired by the individual validation elements.
        this.$element.bind('validate.validation', this.onValidation.bind(this));
    };

    /**
     * Find all elements to validate inside the form.
     * @param {String} selector Css selector for selecting validation elements.
     */
    ValidationForm.prototype.initializeValidations = function(selector) {
        this.validators = this.$element.find(selector);
        this.validators.validation(this.settings);
    };

    /**
     * On submit, check if all the form elements are valid.
     * If not, stop the submit.
     * @param {Event} event The submit event.
     */
    ValidationForm.prototype.onSubmit = function(event) {
        // Validate all element on form submit.
        this.validators.each(function() {
            var validator = $(this).data('Validation');
            if (validator) {
                validator.onValidationEvent.call(validator, event, true, validator.element);
            }
        });

        // if there are invalid elements, stop the submit event.
        if (this.validationStates.invalid.length > 0) {
            event.preventDefault();
            this.$element.addClass(this.settings.classInvalid);
        } else {
            this.$element.removeClass(this.settings.classInvalid);
        }
    };

    /**
     * When an input has been validated, store the results.
     * @param {Event} event The validation event.
     * @param {Object} eventData The parameters send with the event.
     */
    ValidationForm.prototype.onValidation = function(event, eventData) {
        // check if the element is already in the registry.
        for (var state in this.validationStates) {
            if (this.validationStates.hasOwnProperty(state)) {
                var index = this.validationStates[state].indexOf(eventData.element);
                if (index > -1) {
                    // if so, remove it's previous state.
                    this.validationStates[state].splice(index, 1);
                    break;
                }
            }
        }

        if (!this.validationStates[eventData.result]) {
            this.validationStates[eventData.result] = [];
        }
        // store the element with it's current state (valid or invalid).
        this.validationStates[eventData.result].push(eventData.element);
    };

    /**
     * Look for new form elements that need validating.
     */
    ValidationForm.prototype.updateForm = function() {
        this.initializeValidations(this.settings.validationSelector);
    };


    return ValidationForm;

});

